import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * Global service to manage tooltip visibility across the application.
 */
@Injectable({
  providedIn: 'root'
})
export class TooltipManagerService {
  private currentTooltipId$ = new BehaviorSubject<string | null>(null);
  private closeAllTooltips$ = new Subject<void>();

  readonly currentTooltipId = this.currentTooltipId$.asObservable();
  readonly closeAllTooltips = this.closeAllTooltips$.asObservable();

  /**
   * Register a tooltip as the currently active one
   * @param tooltipId Unique identifier for the tooltip
   */
  registerTooltip(tooltipId: string): void {
    if (this.currentTooltipId$.value !== tooltipId) {
      this.currentTooltipId$.next(tooltipId);
    }
  }

  /**
   * Unregister a tooltip if it's currently active
   * @param tooltipId Unique identifier for the tooltip
   */
  unregisterTooltip(tooltipId: string): void {
    if (this.currentTooltipId$.value === tooltipId) {
      this.currentTooltipId$.next(null);
    }
  }

  /**
   * Check if a specific tooltip is currently active
   * @param tooltipId Unique identifier for the tooltip
   */
  isTooltipActive(tooltipId: string): boolean {
    return this.currentTooltipId$.value === tooltipId;
  }

  /**
   * Force close all tooltips
   */
  closeAll(): void {
    this.currentTooltipId$.next(null);
    this.closeAllTooltips$.next();
  }
}
